module.exports = __webpack_public_path__ + "img/av164.6fe36ae7.png";